module.exports = __webpack_public_path__ + "static/img/yunTitle1.18d1d877.png";